import React, { useState,useEffect,useMemo } from "react";
import HeaderHomeAdmin from "../headers/headerHomeAdmin";
import "../css/Statistiques.css";
import Footer from "../components/Footer";
import * as API from "../services/API";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Legend,
  BarChart, 
  Bar
} from "recharts";


function StatCard({ title, value, subtitle }) {
    return (
        <div className="stat-admin__card">
            <p className="stat-admin__cardTitle">{title}</p>
            <h2 className="stat-admin__cardValue">{value}</h2>
            {subtitle && (
                <p className="stat-admin__cardSubtitle">{subtitle}</p>
            )}
        </div>
    );
}

function StatistiqueAdmin() {
        Date.prototype.addDays=function(d){return new Date(this.valueOf()+864E5*d);};
	 	const [visit_count, setVisitCount] = useState([]);
		const [accounts, setAccounts] = useState(0);
        const [dataServer, setDataServer] = useState(null);
        const [connexionCounts,setConnexionCounts] = useState([]);
        const [chartType, setChartType] = useState("line"); // "bar" ou "line"
        const chartData = useMemo(() => {
            const map = new Map();

            visit_count.forEach((visitor) => {
                visitor.seen.forEach((dateStr) => {
                    const day = new Date(dateStr).toISOString().slice(0, 10);

                    if (!map.has(day)) {
                        map.set(day, { date: day, visitors: 0 });
                    }

                    map.get(day).visitors += 1;
                });
            });

            return Array.from(map.values())
                .sort((a, b) => new Date(a.date) - new Date(b.date))
                .map((item) => ({
                    ...item,
                    date: new Date(item.date).toLocaleDateString("fr-FR")
                }));
        }, [visit_count]);
        const visitsBy30thdays = useMemo(() => {
            const now = new Date();

            // Aujourd'hui à 23:59:59
            const endDate = new Date();
            endDate.setHours(23, 59, 59, 999);

            // 30 jours en arrière (inclus aujourd’hui)
            const startDate = new Date();
            startDate.setDate(now.getDate() - 29);
            startDate.setHours(0, 0, 0, 0);

            const map = new Map();

            visit_count.forEach(visitor => {
                visitor.seen.forEach(dateStr => {
                    const date = new Date(dateStr);

                    if (date >= startDate && date <= endDate) {
                        const day = date.toISOString().slice(0, 10);
                        map.set(day, (map.get(day) || 0) + 1);
                    }
                });
            });

            return Array.from(map.entries())
                .sort(([a], [b]) => new Date(a) - new Date(b))
                .map(([date, visitors]) => ({
                    date: new Date(date).toLocaleDateString("fr-FR"),
                    visitors
                }));

        }, [visit_count]);
        const visitsByMonth = useMemo(() => {
            const now = new Date();
            const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
            const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);

            const map = new Map();

            visit_count.forEach(visitor => {
                visitor.seen.forEach(dateStr => {
                    const date = new Date(dateStr);
                    if (date >= startOfMonth && date <= endOfMonth) {
                        const day = date.toISOString().slice(0, 10);
                        map.set(day, (map.get(day) || 0) + 1);
                    }
                });
            });

            return Array.from(map.entries())
                .sort(([a], [b]) => new Date(a) - new Date(b))
                .map(([date, visitors]) => ({ date: new Date(date).toLocaleDateString("fr-FR"), visitors }));
        }, [visit_count]);
        const visitsByYear = useMemo(() => {
            const map = new Map();

            visit_count.forEach(visitor => {
                visitor.seen.forEach(dateStr => {
                const date = new Date(dateStr);
                const yearKey = date.getFullYear(); // Ex: 2026

                if (!map.has(yearKey)) {
                    map.set(yearKey, 0);
                }
                map.set(yearKey, map.get(yearKey) + 1);
                });
            });

            return Array.from(map.entries())
                .sort(([a], [b]) => a - b)
                .map(([year, visitors]) => ({ year, visitors }));
            }, [visit_count]);
            const totalVisitsThisYear = useMemo(() => {
                const date = new Date();
                return visitsByYear
                    .filter(item => item.year === date.getFullYear())
                    .reduce((acc, item) => acc + item.visitors, 0);
            }, [visitsByYear]);

            const totalVisitsThisMonth = useMemo(() => {
            return visitsByMonth.reduce((acc, item) => acc + item.visitors, 0);
            }, [visitsByMonth]);
            const storageData = useMemo(() => {
            if (!dataServer) return [];

            return [
                {
                    name: "Utilisé",
                    value: dataServer.used?Number((dataServer.used / 1024 / 1024 / 1024).toFixed(2)) : 0
                },
                {
                    name: "Libre",
                    value: dataServer.available?Number((dataServer.available / 1024 / 1024 / 1024).toFixed(2)) : 0
                }
            ];
        }, [dataServer]);
        const visitsLast7Days = useMemo(() => {
            const now = new Date();
            const sevenDaysAgo = new Date(now);
            sevenDaysAgo.setDate(now.getDate() - 7);

            return visit_count.reduce((total, visitor) => {
                const count = visitor.seen.filter(date => {
                    const d = new Date(date);
                    return d >= sevenDaysAgo && d <= now;
                }).length;

                return total + count;
            }, 0);
        }, [visit_count]);

        const totalConnexions = useMemo(() => {
            return connexionCounts.reduce(
                (acc, obj) => acc + (obj.connexion_count ? obj.connexion_count : 0),
                0
            );
            }, [connexionCounts]);

            const activeUsersLastMonth = useMemo(() => {
            const now = new Date();
            const oneMonthAgo = new Date();
            oneMonthAgo.setMonth(now.getMonth() - 1);

            return connexionCounts.filter(obj => {
                if (!obj.last_connexion) return false;
                const last = new Date(obj.last_connexion);
                return last >= oneMonthAgo && last <= now;
            }).length;
            }, [connexionCounts]);
	  // Charger les blocs depuis le backend
	  useEffect(() => {
	
		API.getAllStatistiques(
		  (stats) => {
            let data = stats.data.sort((a,b)=>{
                let date1 = new Date(a.first_seen);
                let date2 = new Date(b.first_seen);
                if(date1 < date2){
                    return -1
                }
                if(date1 > date2){
                    return 1
                }
                return 0
            })
			setVisitCount(data);
		  },
		  () => {}
		);
        API.getCountOfAccounts(
		  (stats) => {
			setAccounts(stats.data);
		  },
		  () => {}
		);
        API.getServerStatistiques(
            (stats) => {
			setDataServer(stats.data);
		  },
		  () => {}
        );
        API.getAllConnexionStatistiques((stats)=>{
            setConnexionCounts(stats.data);
        },()=>{});
	  }, []);


    return (
        <div className="stat-admin">
            <HeaderHomeAdmin />

            <div className="stat-admin__container">
                <h1 className="stat-admin__title">Tableau de bord</h1>

                <div className="stat-admin__grid">
                    <StatCard title="Visiteurs"value={visit_count.reduce(
                        (acc, obj) => acc + (obj.seen ? obj.seen.length : 0),
                        0
                        )} subtitle={ visit_count.length
                        ? "depuis le " +
                        new Date(visit_count[0].first_seen).toLocaleDateString("fr-FR")
                        : "Chargement..."} />
                    <StatCard title="Visite dans les 7 derniers jours" value={visitsLast7Days} />
                    <StatCard title="Visite dans ce mois-ci" value={totalVisitsThisMonth} />
                    <StatCard title="Visite de cette année" value={totalVisitsThisYear} />
                    <StatCard title="Connexions totales aux comptes" value={totalConnexions} />
                    <StatCard title="Utilisateurs actifs (30j)" value={activeUsersLastMonth} />
                    <StatCard title="Nombres de comptes" value={accounts} />
                    {/* <StatCard title="Conversion" value="0" subtitle="Stable" /> */}
                </div>

               <div className="stat-admin__largeCard">
                <div className="stat-admin__largeCardHeader">
                    <h2>Évolution du trafic</h2>

                    <button
                    className="stat-admin__chartToggle"
                    onClick={() => setChartType(chartType === "bar" ? "line" : "bar")}
                    >
                    {chartType === "bar" ? "📈 Ligne" : "📊 Barres"}
                    </button>
                </div>

                <ResponsiveContainer width="100%" height={300}>
                    {chartType === "bar" ? (
                    <BarChart data={visitsBy30thdays}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="date" />
                        <YAxis allowDecimals={false} />
                        <Tooltip />
                        <Bar dataKey="visitors" fill="#3b82f6" />
                    </BarChart>
                    ) : (
                    <LineChart data={visitsBy30thdays}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="date" />
                        <YAxis allowDecimals={false} />
                        <Tooltip />
                        <Line
                        type="monotone"
                        dataKey="visitors"
                        stroke="#3b82f6"
                        strokeWidth={3}
                        dot={false}
                        />
                    </LineChart>
                    )}
                </ResponsiveContainer>
                </div>
                <div className="stat-admin__row">

                    <div className="stat-admin__mediumCard">
                        <h2>Stockage serveur</h2>

                        {dataServer && (
                            <ResponsiveContainer width="100%" height={300}>
                                <PieChart>
                                    <Pie
                                        data={storageData}
                                        dataKey="value"
                                        nameKey="name"
                                        cx="50%"
                                        cy="50%"
                                        outerRadius={100}
                                        label={({ percent }) =>
                                            `${(percent * 100).toFixed(0)}%`
                                        }
                                    >
                                        <Cell fill="#ef4444" />
                                        <Cell fill="#22c55e" />
                                    </Pie>
                                     <Tooltip
                                            formatter={(value) => `${value} Go`}
                                        />
                                    <Legend />
                                </PieChart>
                            </ResponsiveContainer>
                        )}
                    </div>
                    <div className="stat-admin__mediumCard">
                         <h2>Performance serveur</h2>
                         <p>Arrive bientôt</p>
                    </div>
                </div>
            </div>
			<Footer />
        </div>
    );
}


export default StatistiqueAdmin;
